import * as React from "react";

import { Box, styled } from "@mui/material";
import { Paper, Spinner, Typography } from "mpulse-design-system";

const LoadingData = () => {
  return (
    <StyledPaper>
      <Typography
        variant="h1"
        color="textPrimary"
        sx={{ marginBottom: (theme) => theme.spacing(4) }}
      >
        Please Wait
      </Typography>
      <Typography
        variant="body1"
        color="textPrimary"
        sx={{ marginBottom: (theme) => theme.spacing(10.5) }}
      >
        We are processing your request
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Spinner color="primary" />
      </Box>
    </StyledPaper>
  );
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(5),
  display: "flex",
  flexDirection: "column",
  height: "500px",
  width: "325px",
  position: "relative",
}));

export default LoadingData;
